export default {"src":"/_next/static/media/icon-wallet.fe2d7814.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};